export enum IconType {
    CLOSE,
    COPY,
    DICE4,
    DICE6,
    DICE8,
    DICE10,
    DICE12,
    DICE20,
    DOANLOAD,
    DRAG,
    EDIT_FILE,
    GEARS,
    HOME,
    PENCIL,
    PLUS,
    TAUNT,
    TRASH,
    UPLOAD_FILE,
    VERY_DISSATISFIED,
    MENU,
    STORE,
    SWORDS,
    GRAPH4,
    GROUP,
    MENU_BOOK,
}

export enum IconTheme {
    LIGHT,
    DARK,
    GREEN,
}

export enum IconSize {
    SMALL = '24px',
    MEDIUM = '32px',
    LARGE = '40px',
    EXTRA_LARGE = '80px',
    RESPONSIVE = '70%',
}
